export default {
  libraryFilters: {
    subject_id: '0',
    grade_id: '0',
    unit_id: '0',
    chapter_position: '0',
    core_concept_id: '0',
    publisher_id: '0',
    media_type: 'all',
    order_by: 'updated_at',
    search_keywords: '',
    share_level: 1,
    offset: 0,
    school_id: '',
    school_year: '0',
  },

  myCardsFilters: {
    subject_id: '0',
    grade_id: '0',
    unit_id: '0',
    core_concept_id: '0',
    chapter_position: '0',
    media_type: 'all',
    order_by: 'updated_at',
    search_keywords: '',
    offset: 0,
    school_year: '0',
  },

  pageLibraryFilters: {
    subject_id: '0',
    grade_id: '0',
    unit_id: '0',
    core_concept_id: '0',
    chapter_position: '0',
    media_type: 'all',
    order_by: 'updated_at',
    is_quiz: '0',
    search_keywords: '',
    offset: 0,
    school_year: '0',
  },

  assignmentsFilters: {
    status: 'all',
    class_id: 'all',
    per_page: 10,
    page: 1,
  },

  subjectMap: {
    0: { name: 'common.selects.all_subjects' },
    9999: { name: 'common.selects.placeholder' },
  },

  gradeMap: {
    0: { name: 'common.selects.all_grades' },
    9999: { name: 'common.selects.placeholder' },
    null: { name: 'common.selects.others' },
  },

  domains: {},

  coreConcepts: {},

  units: {},

  subjectList: [],

  gradeSubjects: [],
};



// WEBPACK FOOTER //
// ./src/app/browse-filters/store/state.js